var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"e4s-flex-row e4s-flex-center"},[_vm._t("before"),_vm._v(" "),_vm._t("field"),_vm._v(" "),_vm._t("after")],2)}
var staticRenderFns = []

export { render, staticRenderFns }